import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { userRoleModification, getSingleUserRole } from "./UserRoleModifyAction";
import {getCSinglePermission} from "../userRolePermission/rolepermissionAction";
import { rolePermissionModification } from "../userRolePermission/rolepermissionAction";
import { useDispatch, useSelector } from "react-redux";
import * as bootstrap from 'bootstrap';
import { useForm } from "react-hook-form";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { useParams , useNavigate} from 'react-router-dom';
import { getAllMenu } from '../menu/menuAction';
import '../userRolePermission/rolepermission.css';
import Swal from "sweetalert2";
import { FaArrowCircleLeft, FaUsers } from 'react-icons/fa';
import Button1 from '@mui/material/Button';
const initialState = {
  id: "",
  userrole: "",
  status: "",

}

const UserRoleModify = () => {
  let navigate = useNavigate();
  const {id}=useParams();
   
  const dispatch = useDispatch();
  const [role, setRole] = useState(initialState);

  const [isAlive, setIsAlive] = useState(true);
  const [alertStatus, setAlertStatus] = useState('');
  const [menus, setMenus] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [checked, setChecked] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [userrole, setUserRole] = useState('');
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);
    const [change , setChange] = useState(true);

    const userRoleData = useSelector((state) => state.userRoleModify);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const { menuisLoading, menu } = useSelector((state) => state.menuList);
  const {combinedpermissiondetails} =useSelector((state)=> state.rolePermissionList)

  const { isloading, mstatus, message, uroles } = useSelector((state) => state.userRoleModify);

  
  useEffect(() => {
    if (combinedpermissiondetails.length > 0) {
      const initialTreeData = mapMenuDataToTree(combinedpermissiondetails);
      setTreeData(initialTreeData);
    }
    setMenus(combinedpermissiondetails);
  }, [combinedpermissiondetails]);

  
 
  useEffect(() => { 

     loadUserRole(id);
     return () => setIsAlive(false);
        
    }, [isAlive]);

      function loadUserRole(id){
       // dispatch(getSingleUserRole(id));
       dispatch(getCSinglePermission(id))
        setRole({id:id,userrole:"",status:""});
     }
    //  const uData = JSON.parse(JSON.stringify(userRoleData.uroles));
    const uData = combinedpermissiondetails.map((item)=>{
      return item
    });
    console.log("mkiii",uData[0]?.user_role);
    console.log('combinedpermissiondetails',combinedpermissiondetails);




function mapMenuDataToTree(menuItems, userStatus) {
  
  const sortedMenuItems = [...menuItems].sort((a, b) => a.sort - b.sort);
  return sortedMenuItems
    .filter((menuItem) => menuItem.parent_id === 0)
    .map((menuItem) => {
      const childNodes = menuItems.filter(
        (childItem) => childItem.parent_id === menuItem.menu_id
      );
      const children = childNodes.map((childNode) => {
        const isChildChecked = childNode.user_status === 1;
        const isChildPartial = isChildChecked && !isAllChildrenChecked(childNode);
        return {
          id: childNode.id,
          value: childNode.label,
          label: childNode.label,
          menu_id:childNode.menu_id,
          children: mapMenuDataToTree(
            menuItems.filter((childItem) => childItem.parent_id === childNode.menu_id),
            userStatus
          ),
          status: isChildChecked ? 1 : 0,
          checked: isChildChecked,
          indeterminate: isChildPartial,
        };
      });

      const isMainChecked = menuItem.user_status === 1;
      const isMainPartial = isMainChecked && !isAllChildrenChecked(menuItem);

      return {
        id: menuItem.id,
        value: menuItem.label,
        label: menuItem.label,
        menu_id:menuItem.menu_id,
        children: children.length > 0 ? children : null,
        status: isMainChecked ? 1 : 0,
        checked: isMainChecked,
        indeterminate: isMainPartial,
      };
    });
}

  
  function isAllChildrenChecked(node) {
    if (!node.children) {
      return checked.includes(node.id);
    }
  
    const childrenIds = node.children.map((child) => child.id);
    const checkedChildren = childrenIds.filter((id) => checked.includes(id));
  
    return childrenIds.length === checkedChildren.length;
  }
  
  
  const handleCheckAll = () => {
    const updatedTreeData = toggleAllNodeStatus(treeData, 1);
    setTreeData(updatedTreeData);
    setChange(false)
  };
  
  const handleUncheckAll = () => {
    const updatedTreeData = toggleAllNodeStatus(treeData, 0);
    setTreeData(updatedTreeData);
    setChange(false)
  };
  
  

  function toggleAllNodeStatus(nodes, status) {
    return nodes.map((node) => {
      const updatedNode = {
        ...node,
        status,
        checked: status === 1,
        indeterminate: false,
      };
  
      if (node.children) {
        updatedNode.children = toggleAllNodeStatus(node.children, status);
      }
  
      return updatedNode;
    });
  }

  const handleOnChange = e => {
    setChange(false)
    const name = e.target.name;
    const value = e.target.value;
     
    setRole({ ...role, [name]: value });

    };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
  
    const { id, userrole, status } = role;
    const UserUpdation = {id,
      userrole,
      status,
    };
    try {
       dispatch(userRoleModification(UserUpdation));
      setModify(1);
     
      const rolePermissions = treeData.reduce((permissions, menuItem) => {
        
        const permission = {
          userroleid: id,
          menuid: menuItem.menu_id,
          status: menuItem.status,
          // status property of the node
        };

      
        permissions.push(permission);
        if (menuItem.children) {
          menuItem.children.forEach((childNode) => {
            const childPermission = {
              userroleid: id,
              menuid: childNode.menu_id,
              status: childNode.status, //  status property of the node
            };
          
            permissions.push(childPermission);
            setIsAlive(true)
          });
        }
        return permissions;
      }, []);
  
      const rolePermissionPromises = rolePermissions.map((permission) => {
        
        return dispatch(rolePermissionModification(permission));
      });
  
      await Promise.all(rolePermissionPromises);
      Swal.fire('Success', 'User role updated successfully', 'success');
      navigate("/allRoles");
  
      e.target.reset();
    } catch (error) {
      // Handle errors
      
      // Display an error message or perform any necessary actions
    }
    setChange(true)
  };
  function handleCheckboxChange(nodeId) {
    const updatedTreeData = toggleNodeStatus(treeData, nodeId);
    setTreeData(updatedTreeData);
    setChange(false)
  }
  
 
  function updateDescendants(nodes, parentNode) {
    if (!parentNode.children) {
      return parentNode;
    }
  
    const updatedChildren = parentNode.children.map((childNode) => {
      const updatedChildNode = {
        ...childNode,
        checked: parentNode.checked,
        indeterminate: false,
        status: parentNode.checked ? 1 : 0,
      };
      return updateDescendants(childNode.children, updatedChildNode);
    });
  
    return {
      ...parentNode,
      children: updatedChildren,
    };
  }

  
  function toggleNodeStatus(nodes, targetNode) {
    const updatedNodes = nodes.map((node) =>  {
      if (node.id === targetNode.id) {
        const newChecked = !targetNode.checked;
        const isAllChildrenChecked = node.children?.every((child) => child.checked);
       
        const isSomeChildrenChecked = node.children?.some((child) => child.checked || child.indeterminate);
        const indeterminate = !isAllChildrenChecked && isSomeChildrenChecked;
  
        const updatedNode = {
          ...targetNode,
          checked: newChecked,
          indeterminate: indeterminate,
          status: indeterminate ? 1 : (newChecked ? 1 : 0),
        };
        return updateDescendants(nodes, updatedNode);
      }
  
      if (node.children) {
        const updatedChildren = toggleNodeStatus(node.children, targetNode);
        const isAllChildrenChecked = updatedChildren.every((child) => child.checked);
        const isSomeChildrenChecked = updatedChildren.some((child) => child.checked || child.indeterminate);
        const indeterminate = !isAllChildrenChecked && isSomeChildrenChecked;
  
        return {
          ...node,
          children: updatedChildren,
          indeterminate: indeterminate,
          status: indeterminate ? 1 : (node.checked ? 1 : 0),
        };
      }
  
      return node;
    });
  
    return updateAncestors(updatedNodes, targetNode);
  }
 
  


  function updateAncestors(nodes, targetNode) {
    const parent = findParentNode(nodes, targetNode);
  
    if (parent) {
      const allSiblings = parent.children || [];
      const checkedSiblings = allSiblings.filter((sibling) => sibling.checked || sibling.indeterminate);
  
      const newParent = {
        ...parent,
        checked: checkedSiblings.length === allSiblings.length,
        indeterminate: checkedSiblings.length > 0 && checkedSiblings.length !== allSiblings.length,
      };
  
      const updatedNodes = nodes.map((node) => {
        if (node.id === parent.id) {
          return newParent;
        }
  
        if (node.children) {
          return {
            ...node,
            children: toggleNodeStatus(node.children, targetNode),
          };
        }
  
        return node;
      });
  
      return updateAncestors(updatedNodes, newParent);
    }
  
    return nodes;
  }
  
  
  function findParentNode(nodes, targetNode) {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
  
      if (node.children) {
        if (node.children.some((child) => child.id === targetNode.id)) {
          return node;
        }
  
        const parentNode = findParentNode(node.children, targetNode);
        if (parentNode) {
          return parentNode;
        }
      }
    }
  
    return null;
  }
  function handleExpand(node) {
    const updatedTreeData = toggleNodeExpanded(treeData, node);
    setTreeData(updatedTreeData);
  }
  
  function toggleNodeExpanded(nodes, targetNode) {
    return nodes.map((node) => {
      if (node.id === targetNode.id) {
        return { ...node, expanded: !node.expanded };
      }
  
      if (node.children) {
        return {
          ...node,
          children: toggleNodeExpanded(node.children, targetNode),
        };
      }
  
      return node;
    });
  }
  
 
  function renderCheckboxTree(nodes, isChildNode = false) {
    console.log(nodes);
    return nodes.map((node) => {
      const hasCheckedChildren = node.children && node.children.some(child => child.status === 1);
      const allChildrenChecked = node.children && node.children.every(child => child.status === 1);
   
      const indeterminate = node.children && !allChildrenChecked && hasCheckedChildren;
      

      
        
  
      return (
        <div key={node.id} className={isChildNode ? 'child-node' : 'parent-node'}>
          <div onClick={() => handleExpand(node)} className="node-label">
            {!isChildNode && node.children && (
              <i className="parent-icon fa fa-chevron-right"></i>
            )}
        
            {isChildNode && <div className="spacer" />}
            <Form.Check
              type="checkbox"
              id={`menu-${node.id}`}
              label={node.label}
              checked={node.status === 1 ? 1 : 0} 
             
              
              onChange={() => handleCheckboxChange(node)}
              onClick={(e) => e.stopPropagation()}
               className={indeterminate ? 'partially-checked' : ''}
            

             
              indeterminate={indeterminate}
            />
          </div>
          {node.children && node.expanded && (
            <div className="child-nodes">
              {renderCheckboxTree(node.children, true)}
            </div>
          )}
        </div>
      );
    });
  }
  
  
  
  return (
    <>
        <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify User Role</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <div><Button1 variant='contained' style={{backgroundColor:'#d1af2b'}} onClick={() => navigate('/allRoles')}><FaArrowCircleLeft className="ml-2 me-2" />Back to User Role List
        </Button1></div>
   
                        </Row>
                        <br />
           
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              {/* <Row className="mb-3"> */}
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>User Role</Form.Label>
                  <Form.Control type="text"  name="userrole" autoComplete='off' placeholder="Enter User Role" value={role.userrole ? role.userrole : uData[0]?.user_role} {...register("userrole", { required: true, maxLength: 10 })} maxLength={50} onChange={handleOnChange}  style={{ width: "500px" }}/>
                 
                </Form.Group>
                {errors.userrole && <p>Please check the First Name</p>}
                <Form.Group as={Col} controlId="formGridStatus" className='mt-4' style={{ width: "500px"}}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status")} onChange={handleOnChange} value={role.status ? role.status : uData[0]?.status}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                </Form.Group>
                <Card className='mt-5'>
                  <div className='mt-3 ms-3 mb-5'>
                  <div>
      <h5>Permission Menu List</h5>
     
        <div className="ms-3 custom-tree">
          <div className="my-container">
            <div className="my-custom-styles">
                 {renderCheckboxTree(treeData)}

            </div>
          </div>
        </div>
    
        <div className='mt-4'>
  <input type="button" className='btn btn-primary btn-sm' value="Check All" onClick={handleCheckAll} style={{ backgroundColor: "#1B3D6D", color: "white" }} />
  <input type="button" className='btn btn-primary btn-sm ms-4' value="Uncheck All" onClick={handleUncheckAll} style={{ backgroundColor: "#1B3D6D", color: "white" }}/>
</div>


    

    </div>
                </div>
                </Card>
              {/* </Row> */}
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle mt-3'
               style={{
                backgroundColor: "#003893",
                color: "white",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "0.25rem",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#002770")}
           onMouseOut={(e) => (e.target.style.backgroundColor = "##1B3D6D")}
           disabled={change}
            >
                Submit
              </Button>
              </div>
              {isloading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default UserRoleModify;